import { useModalRoot } from "@digits-shared/hooks/useModalRoot"
import useRouter from "@digits-shared/hooks/useRouter"
import { useWaitForElement } from "@digits-shared/hooks/useWaitForElement"
import routes from "src/frontend/routes"

export function useTransactionUpdatesHeaderRoot() {
  const { location } = useRouter()
  const isDetailsView = !!routes[location.name]?.config.detailsViewAction
  const mainRoot = useWaitForElement("application-header-portal")
  const detailsRoot = useWaitForElement("details-header-portal")
  const modalRoot = useModalRoot()
  return (isDetailsView ? detailsRoot : mainRoot) ?? modalRoot
}
